module.exports = __webpack_public_path__ + "static/media/list-music.0cbdad69.svg";